import { z } from "zod";
import { OAuthProviderSchema } from "./oauth-providers";

export const IntegrationTokenSchemaOld = z.object({
  id: z.string(),
  provider: OAuthProviderSchema,
  scope: z.string(),
  userId: z.string(),
  accessToken: z.string(),
  refreshToken: z.string(),
  expiresAt: z.coerce.date(),
  externalUserId: z.string().nullish(),
});

// Renamed because will be deleted later after full migration / end of project
export type IntegrationTokenOld = z.infer<typeof IntegrationTokenSchemaOld>;
